module.exports = __webpack_public_path__ + "img/jiyong_song-min.f234bb76.jpg";